let idCounter = 0;

export function generateId(prefix = "ui-bottom-sheet-dialog-"): string {
  idCounter += 1;
  return `${prefix}${idCounter}`;
}
